import { TeamRoute } from '@/modules/team/routes/team.routes';
import { RouteConfig } from 'vue-router';

export const router: RouteConfig[] = [
  {
    path: `/${TeamRoute.TEAM_INVITE_EXPIRED.path}`,
    name: `/${TeamRoute.TEAM_INVITE_EXPIRED.name}`,
    component: () => import('@/modules/team/pages/TeamTeamInviteExpiredPage.vue')
  }
];
